import {
  type UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import api from '@/axios';
import type { PurchaseOrderCommentValues } from '@/features/purchase-order/schema/purchase-order-comment-schema';
import { GET_PURCHASE_ORDER_KEY } from '@/keys';

const editPurchaseOrderComment = async ({
  id,
  value,
}: PurchaseOrderCommentValues): Promise<void> => {
  await api.patch(`/purchase-order-comments/${id}`, {
    value,
  });
};

export function useEditPurchaseOrderComment(
  purchaseOrderId: string,
): UseMutationResult<void, Error, PurchaseOrderCommentValues> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: editPurchaseOrderComment,
    onSuccess: async (_data) => {
      await queryClient.invalidateQueries({
        queryKey: [...GET_PURCHASE_ORDER_KEY, purchaseOrderId],
      });
    },
  });
}
